import { getRequest } from 'apis/ApiInstence';
import axiosInstance from 'apis/axiosConfig';
import { put } from 'redux-saga/effects';
import { successOrderListDB, failedOrderListDB } from 'slice/orderSliceDB';

const isSuccessfulResponse = (response) => response?.status >= 200 && response?.status < 300;

const getOrderErrorPayload = (error) =>
  error?.response?.data ||
  error?.data ||
  error || {
    message: 'Unable to update order.'
  };

export function* updateOrderAPI({ payload }) {
  try {
    const updateResponse = yield axiosInstance.patch(`/order/${payload.id}`, payload.data);

    if (!isSuccessfulResponse(updateResponse)) {
      yield put(failedOrderListDB(getOrderErrorPayload(updateResponse)));
      return;
    }

    const response = yield getRequest('order');
    if (response?.status === 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(getOrderErrorPayload(response)));
    }
  } catch (error) {
    console.log(error);
    yield put(failedOrderListDB(getOrderErrorPayload(error)));
  }
}
